var _mask, _path, _mask2, _path2, _mask3, _path3, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignBefor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 10,
    viewBox: "0 0 247 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_576_439",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H10V10H0V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-1H-1V0H0ZM10 0H11V-1H10V0ZM10 10V11H11V10H10ZM0 10H-1V11H0V10ZM0 0V1H10V0V-1H0V0ZM10 0H9V10H10H11V0H10ZM10 10V9H0V10V11H10V10ZM0 10H1V0H0H-1V10H0Z",
    fill: "#7CAF92",
    mask: "url(#path-1-inside-1_576_439)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_576_439",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 0H36V10H26V0Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 0V-1H25V0H26ZM36 0H37V-1H36V0ZM36 10V11H37V10H36ZM26 10H25V11H26V10ZM26 0V1H36V0V-1H26V0ZM36 0H35V10H36H37V0H36ZM36 10V9H26V10V11H36V10ZM26 10H27V0H26H25V10H26Z",
    fill: "#7CAF92",
    mask: "url(#path-3-inside-2_576_439)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_576_439",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 0H62V10H52V0Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 0V-1H51V0H52ZM62 0H63V-1H62V0ZM62 10V11H63V10H62ZM52 10H51V11H52V10ZM52 0V1H62V0V-1H52V0ZM62 0H61V10H62H63V0H62ZM62 10V9H52V10V11H62V10ZM52 10H53V0H52H51V10H52Z",
    fill: "#7CAF92",
    mask: "url(#path-5-inside-3_576_439)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: 4.5,
    x2: 246.5,
    y2: 4.5,
    stroke: "#95D2AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignBefor);
export default __webpack_public_path__ + "static/media/design-befor.5de3993784c43d3a2b5c5ea63bafabfd.svg";
export { ForwardRef as ReactComponent };